<script setup>
definePage({
  meta: {
    layout: 'default',
    action: 'read',
    subject: 'UserGuide',
  },
})

const guides = [
  {
    title: 'Toggle F&B & Retail',
    route: 'userguide-retail-toggle',
    icon: 'ri-store-3-line',
    color: 'primary',
    description: 'Aktifkan fitur Retail berdampingan dengan F&B (hybrid), tanpa kehilangan menu yang sudah dipakai',
    available: true,
  },
  {
    title: 'Scan Barcode di Kasir',
    route: 'userguide-retail-barcode',
    icon: 'ri-barcode-line',
    color: 'success',
    description: 'Isi barcode produk, lalu scan/ketik + Enter di kasir untuk masuk keranjang otomatis',
    available: true,
  },
  {
    title: 'Harga Grosir Bertingkat',
    route: 'userguide-retail-harga-grosir',
    icon: 'ri-price-tag-3-line',
    color: 'warning',
    description: 'Atur harga lebih murah per satuan kalau dibeli dalam jumlah banyak (mis. 1 dus)',
    available: true,
  },
  {
    title: 'Tracking Kedaluwarsa',
    route: 'userguide-retail-kedaluwarsa',
    icon: 'ri-calendar-close-line',
    color: 'error',
    description: 'Catat tanggal kedaluwarsa saat terima barang, pantau lewat laporan Stok Kedaluwarsa',
    available: true,
  },
]
</script>

<template>
  <div>
    <RouterLink to="/userguide">
      <VBtn
        variant="text"
        prepend-icon="ri-arrow-left-line"
        class="mb-2"
      >
        Kembali ke Daftar Modul
      </VBtn>
    </RouterLink>

    <div class="d-flex align-center mb-4">
      <VAvatar
        color="orange"
        variant="tonal"
        size="64"
        rounded="lg"
        class="me-4"
      >
        <VIcon
          icon="ri-shopping-bag-3-line"
          size="36"
        />
      </VAvatar>
      <div>
        <h4 class="text-h4 font-weight-bold mb-1">
          Fitur Retail
        </h4>
        <p class="text-body-1 text-medium-emphasis mb-0">
          Fitur tambahan untuk toko/minimarket: scan barcode, harga grosir bertingkat, dan
          tracking kedaluwarsa
        </p>
      </div>
    </div>

    <VAlert
      type="info"
      variant="tonal"
      class="mb-6"
      icon="ri-information-line"
    >
      Fitur di bagian ini khusus untuk bisnis yang jual barang eceran (toko kelontong,
      minimarket, apotek, dsb) — <strong>bukan pengganti</strong> fitur F&amp;B, melainkan
      tambahan yang bisa diaktifkan berdampingan (hybrid) lewat menu Pengaturan.
    </VAlert>

    <VRow>
      <VCol
        v-for="guide in guides"
        :key="guide.title"
        cols="12"
        md="6"
        lg="4"
      >
        <VCard
          variant="outlined"
          :class="{ 'opacity-60': !guide.available }"
          :hover="guide.available"
        >
          <VCardText>
            <div class="d-flex align-center mb-3">
              <VAvatar
                :color="guide.color"
                variant="tonal"
                size="48"
                class="me-3"
              >
                <VIcon
                  :icon="guide.icon"
                  size="26"
                />
              </VAvatar>
              <div>
                <h6 class="text-h6 font-weight-bold mb-0">
                  {{ guide.title }}
                </h6>
                <VChip
                  v-if="!guide.available"
                  size="x-small"
                  color="grey"
                  class="mt-1"
                >
                  Segera Hadir
                </VChip>
              </div>
            </div>
            <p class="text-body-2 text-medium-emphasis mb-4">
              {{ guide.description }}
            </p>
            <VBtn
              v-if="guide.available"
              :to="{ name: guide.route }"
              variant="tonal"
              :color="guide.color"
              block
            >
              Baca Panduan
            </VBtn>
            <VBtn
              v-else
              variant="tonal"
              color="grey"
              block
              disabled
            >
              Belum Tersedia
            </VBtn>
          </VCardText>
        </VCard>
      </VCol>
    </VRow>
  </div>
</template>
